const debounce = (fn, delay) => {
    let timeoutID = null;
    return function () {
        clearTimeout(timeoutID);
        const args = arguments;
        const that = this;
        timeoutID = setTimeout(function () {
            fn.apply(that, args);
        }, delay);
    };
};


const fromStorage = (key) => {
    let ret = null;
    ret = localStorage.getItem(key);
    return ret;
};

const toStorage = (key, value) => {
    let ret = null;
    localStorage.setItem(key, value);
    return ret;
};

const highlight_element = (el, times) => {
    el.style['background-color'] = "#F00";
    el.style["transition"] = "background-color 0.09s ease";
    setTimeout(() => {
        el.style['background-color'] = "#FFF";
    }, 150);
    if (times - 1 > 0) {
        setTimeout(() => {
            highlight_element(el, times - 1);
        }, 300);
    }
};

const languageMapping = (language) => {
    let ret;
    switch (language) {
        case "en":
            ret = "gb";
            break;
        case "da":
            ret = "dk";
            break;
        case "ca":
            ret = "es";
            break;
        case "he":
            ret = "il";
            break;
        case "iw":
            ret = "il";
            break;
        case "yi":
            ret = "il";
            break;
        case "sv":
            ret = "se";
            break;
        case "vi":
            ret = "vn";
            break;
        case "uk":
            ret = "ua";
            break;
        case "cs":
            ret = "cz";
            break;
        case "sl":
            ret = "si";
            break;
        case "zh":
            ret = "cn";
            break;
        case "ko":
            ret = "kr";
            break;
        case "et":
            ret = "ee";
            break;
        case "am":
            ret = "et";
            break;
        case "ga":
            ret = "ie";
            break;
        case "el":
            ret = "gr";
            break;
        case "ka":
            ret = "ge";
            break;
        case "hi":
            ret = "in";
            break;
        case "te":
            ret = "in";
            break;
        case "ja":
            ret = "jp";
            break;
        case "nb":
            ret = "no";
            break;
        case "tha":
            ret = "th";
            break;
        case "ny":
            ret = "mw";
            break;
        default:
            ret = language;
            break;
    }
    return ret;
};

function formatDate(date, format = "YYYY-MM-DD") {
    if (!date) return "";
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');

    switch (format) {
        case "YYYY-MM-DD":
            return `${year}-${month}-${day}`;
        case "DD/MM/YYYY":
            return `${day}/${month}/${year}`;
        case "MM/DD/YYYY":
            return `${month}/${day}/${year}`;
        default:
            return date; // Return original date if format is unknown
    }
}

export default {
    debounce,
    formatDate,
    fromStorage,
    toStorage,
    highlight_element,
    languageMapping
};

